 <template>
    <div>
        <!-- Start -->
       <section class="relative md:py-24 py-16" id="about">
          <div class="container mx-auto">
              <div class="grid grid-cols-1 lg:grid-cols-12 md:grid-cols-2 gap-10 items-center">
                  <div class="lg:col-span-5">
                      <img src="../assets/images/about.jpg" class="rounded-lg shadow-lg relative" alt="">
                  </div><!--end col-->

                  <div class="lg:col-span-7">
                      <div class="lg:ms-7">
                        <h3 class="mb-4 md:text-2xl text-xl font-medium">Qui sommes-nous</h3>

                        <p class="text-slate-400 dark:text-slate-300 max-w-2xl mx-auto">
                          RH Paie Plus est une SASU spécialisée dans l’externalisation premium de la paie et le conseil social,
                          basée au 18 rue de la Concertation, 75018 Paris. Notre cabinet accompagne les TPE et PME à
                          la recherche d’un service fiable, rigoureux et conforme aux exigences légales, tout en offrant une
                          approche personnalisée et réactive.
                        </p>
                        <br>
                        <p class="text-slate-400 dark:text-slate-300 max-w-2xl mx-auto">
                          Nous prenons en charge l’ensemble du processus de paie : élaboration des bulletins, gestion des
                          variables, entrées et sorties de salariés, déclarations sociales (DSN, URSSAF, retraite, prévoyance) et
                          accompagnement sur les obligations légales. Chaque dossier est traité avec précision, confidentialité et
                          un souci constant d’exactitude.
                        </p>
                        <br>
                        <p class="text-slate-400 dark:text-slate-300 max-w-2xl mx-auto">
                          Grâce à une expertise avancée en paie et en réglementation sociale, RH Paie Plus devient un partenaire
                          de confiance pour votre entreprise. Nous adaptons nos services aux particularités de votre convention
                          collective et aux évolutions de votre organisation, afin de sécuriser chaque étape de votre cycle
                          social.
                        </p>
                        <br>
                        <p class="text-slate-400 dark:text-slate-300 max-w-2xl mx-auto">
                          Notre engagement est simple : offrir à votre entreprise une gestion de paie fluide, rigoureuse et
                          totalement sereine, mois après mois. Avec RH Paie Plus, vous gagnez en temps, en conformité et en
                          tranquillité, tout en bénéficiant d’un accompagnement professionnel et sur mesure.
                        </p>
                      </div>
                  </div><!--end col-->
              </div><!--end grid-->
          </div><!--end container-->
      </section><!--end section-->
      <!-- End -->
    </div>
 </template>
 
 <script>
 import feather from 'feather-icons'

    export default {
        name: "AboutUs",
        data() {
            return {
                
            }
        },
        mounted() {
        feather.replace();
        }
    }
 </script>
 
 <style lang="scss" scoped>
 
 </style>